import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import Box from '@mui/material/Box';
import { WHITE } from '../../common/colorConstants';
import { jsx as _jsx } from "react/jsx-runtime";
export function IndicatorBadgeImage(props) {
  var imageAltText = props.imageAltText,
    imageSrc = props.imageSrc,
    _props$size = props.size,
    size = _props$size === void 0 ? 'xs' : _props$size,
    sx = props.sx;
  return /*#__PURE__*/_jsx(Box, {
    sx: _extends({
      '>img': {
        height: imgSize[size].size,
        width: imgSize[size].size
      },
      alignItems: 'center',
      background: "var(--".concat(imageAltText, ",").concat(imageSrc, ", lightgray 50% / cover no-repeat)"),
      borderColor: WHITE,
      borderRadius: size === '2xl' ? '13.333px' : '12px',
      borderStyle: 'solid',
      borderWidth: size === '2xl' ? '1.667px' : '1.5px',
      display: 'flex',
      height: imgSize[size].size,
      justifyContent: 'center',
      width: imgSize[size].size
    }, sx),
    "data-element": "Box",
    "data-component": "IndicatorBadgeImage",
    "data-source-file": "IndicatorBadgeImage.tsx",
    children: /*#__PURE__*/_jsx("img", {
      alt: "".concat(imageAltText),
      src: imageSrc
    })
  });
}
export var imgSize = {
  '2xl': {
    size: 20
  },
  lg: {
    size: 16
  },
  md: {
    size: 14
  },
  sm: {
    size: 12
  },
  xl: {
    size: 18
  },
  xs: {
    size: 10
  }
};